import * as GTM from "./trackingUserEvents";

export const trackViewCar = (car) => {
  const item = {
    item_id: toString(car?.productNo ?? car?.slug ?? car?.Slug ?? car?.ProductID, ""),
    item_name: toString(car?.name ?? car?.nameEn ?? car?.modelTypes ?? car?.modelTypesEn, ""),
    affiliation: "value",
    coupon: "value",
    discount: 0,
    index: 0,
    item_brand: toString(car?.brand ?? car?.brandEn, "value"),
    item_category: toString(car?.group ?? car?.groupEn, "value"),
    item_category2: toString(car?.year, "value"),
    item_category3: toString(car?.vehicleType ?? car?.category, "value"),
    item_category4: toString(car?.carGroupID, "value"),
    item_category5: "value",
    item_list_id: "value",
    item_list_name: "value",
    item_variant: toString(car?.colorNameEn ?? car?.colorName, "value"),
    location_id: "value",
    price: toNumber(car?.minPrice ?? car?.price ?? car?.NetSalePrice, 0),
    quantity: 1,
  };

  GTM.trackViewItem([item], "SAR", item.price);
};

export const trackViewCart = (items, currency) => {
  const value = items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
  GTM.trackViewCart(items, currency, value);
};

export const trackViewCarList = (listId, listName, cars, currency) => {
  // map cars to items if needed, assuming cars are already mapped or close enough
  GTM.trackViewItemList(cars, listId, listName, currency);
};

export const trackPurchase = (orderId, total, tax, shipping = 0, coupon = "", items, currency = "SAR") => {
  GTM.trackPurchase(orderId, total, currency, tax, shipping, coupon, items);
};

export const trackGenerateLead = (total, currency = "SAR") => {
  GTM.pushEvent("generate_lead", {
    currency: currency,
    value: total,
    lead_source: "website"
  });
};

export const trackViewOfferCar = (dtoOrPayload) => {
  const payload = typeof dtoOrPayload?.toJSON === "function" ? dtoOrPayload.toJSON() : dtoOrPayload;
  GTM.pushEvent("view_promotion", payload);
};

export const trackSelectOfferCar = (dtoOrPayload) => {
  const payload = typeof dtoOrPayload?.toJSON === "function" ? dtoOrPayload.toJSON() : dtoOrPayload;
  GTM.pushEvent("select_promotion", payload);
};

export const trackSearch = (searchTerm) => {
  GTM.trackSearch(searchTerm);
};

export const trackBeginCheckout = (item, currency = "SAR") => {
  const price = item?.price ? Number(item.price) : 0;
  const quantity = item?.quantity ? Number(item.quantity) : 1;
  const value = price * quantity;

  GTM.trackBeginCheckout([item], currency, value);
};

export const trackAddToCart = (item, currency = "SAR") => {
  const price = item?.price ? Number(item.price) : 0;
  const quantity = item?.quantity ? Number(item.quantity) : 1;
  const value = price * quantity;

  GTM.trackAddToCart([item], currency, value);
};

export const trackAddToWishlist = (item, currency = "SAR") => {
  const price = item?.price ? Number(item.price) : 0;
  const quantity = item?.quantity ? Number(item.quantity) : 1;
  const value = price * quantity;

  GTM.trackAddToWishlist([item], currency, value);
};

export const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

export const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));

export const mapCartItemToJournifyItem = (car, idx = 0, creativeSlot) => ({
  item_id: toString(car?.ProductID ?? car?.productNo ?? car?.Slug ?? car?.guid ?? car?.id, ""),
  item_name: toString(car?.nameEn ?? car?.modelTypesEn ?? car?.DescriptionEn ?? car?.name ?? car?.modelTypes, ""),
  affiliation: "value",
  coupon: "value",
  discount: toNumber(car?.Discount ?? car?.discount, 0),
  index: idx,
  item_brand: toString(car?.brandEn ?? car?.brand, "value"),
  item_category: toString(car?.groupEn ?? car?.group, "value"),
  item_category2: toString(car?.year ?? car?.modelYear, "value"),
  item_category3: toString(car?.category ?? car?.vehicleType, "value"),
  item_category4: toString(car?.carGroupID ?? car?.groupID, "value"),
  item_category5: toString(car?.type ?? car?.modelTypeID, "value"),
  item_variant: toString(car?.colorNameEn ?? car?.colorName, "value"),
  location_id: toString(creativeSlot, "value"),
  price: toNumber(car?.price ?? car?.NetSalePrice, 0),
  quantity: toNumber(car?.quantity ?? car?.QTY, 1),
});


export const trackSelectCar = (car, listId, listName, currency = "SAR") => {
  const item = {
    item_id: toString(car?.ProductID ?? car?.productNo ?? car?.slug ?? car?.guid ?? car?.id, ""),
    item_name: toString(car?.nameEn ?? car?.modelTypesEn ?? car?.DescriptionEn ?? car?.name ?? car?.modelTypes, ""),
    affiliation: "value",
    coupon: "value",
    discount: toNumber(car?.Discount ?? car?.discount, 0),
    index: 0,
    item_brand: toString(car?.brandEn ?? car?.brand, "value"),
    item_category: toString(car?.groupEn ?? car?.group, "value"),
    item_category2: toString(car?.year ?? car?.modelYear, "value"),
    item_category3: toString(car?.category ?? car?.vehicleType, "value"),
    item_category4: toString(car?.carGroupID ?? car?.groupID, "value"),
    item_category5: toString(car?.type ?? car?.modelTypeID, "value"),
    item_variant: toString(car?.colorNameEn ?? car?.colorName, "value"),
    location_id: "value",
    price: toNumber(car?.price ?? car?.NetSalePrice ?? car?.minPrice, 0),
    quantity: 1,
  };

  GTM.trackSelectItem([item], listId, listName, currency);
};

export const trackShare = (method, contentType, itemId) => {
  GTM.trackShare(method, contentType, itemId);
}

export const trackAddShippingInfo = (items, shippingTier, currency, value, coupon) => {
  GTM.trackAddShippingInfo(items, currency, value, shippingTier, coupon);
}

// export const trackAddPaymentInfo = (items, currency, value, paymentType, coupon) => {
//   GTM.trackAddPaymentInfo(items, currency, value, paymentType, coupon);
// }

export const trackRemoveFromCart = (items, currency = "SAR") => {
  const itemsArray = Array.isArray(items) ? items : [items];
  const value = itemsArray.reduce((acc, item) => acc + (toNumber(item.price) * toNumber(item.quantity, 1)), 0);
  GTM.trackRemoveFromCart(itemsArray, currency, value);
};
